import { Component } from "@angular/core";
import { AppRoutes } from "src/app/constants";

@Component({
  selector: "app-reports",
  templateUrl: "./reports.page.html",
  styleUrls: ["./reports.page.scss"],
})
export class ReportsPage {
  public routes: typeof AppRoutes = AppRoutes;
  public logoImagePath: string;
  public avatarImagePath: string;
  public order: number;
  public showOrder = false;
  public graphPosition = 0;

  public breadcrumbs = [
    {
      name: "Home",
      link: "/home",
    },
    {
      name: "Reports",
      link: "/reports",
    },
  ];

  public reports = [
    {
      name: "Kunden gewinnen",
      color: "119, 154, 78",
    },
    {
      name: "Kunden bedienen",
      color: "199, 115, 115",
    },
    {
      name: "Kunden binden",
      color: "232, 163, 81",
    },
    {
      name: "Ressourcen einsetzen",
      color: "119, 154, 78",
    },
    {
      name: "Finanzen managen",
      color: "199, 115, 115",
    },
    {
      name: "Mitarbeiter organisieren",
      color: "232, 163, 81",
    },
    {
      name: "Betrieb organisieren",
      color: "153, 145, 140",
    },
  ];

  public user = {
    name: "Anna Reckless",
    avatarImage: "anna.svg",
  };

  constructor() {
    this.logoImagePath = "./assets/logo.png";
    this.avatarImagePath = `./assets/avatar/${this.user.avatarImage}`;
  }

  public showGraph(index): void {
    this.graphPosition = index;
    if (this.showOrder === true && this.order === index) {
      this.showOrder = false;
    } else if (this.showOrder === true) {
      this.showOrder = !this.showOrder;
      setTimeout(() => {
        this.showOrder = !this.showOrder;
        this.order = index;
      }, 500);
    } else {
      this.order = index;
      this.showOrder = !this.showOrder;
    }
  }
}
